import $ from 'jquery';
import Swal from 'sweetalert2';

export default function () {
    $('.js-subs-email').on('submit', function (e) {
        e.preventDefault();

        if (!$(this).valid())
            return;

        const formData = new FormData($(this)[0]);
        const $that = $(this);
        window.waitMe($(this));

        $.ajax({
            url: window.GLOBALS.baseLink + 'email-abonelik',
            type: 'POST',
            data: formData,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    if (response.IsSuccess) {
                        Swal.fire(response.Title, response.Message, response.Class, );
                        if (response.Redirect) {
                            setTimeout(function () {
                                window.location.href = response.Redirect;
                            }, 1000)
                        }
                        window.closeWaitMe($that);
                        $('.js-subs-email')[0].reset();
                    } else {
                        Swal.fire(response.Title, response.Message, {
                            icon: response.Class,
                            buttons: false
                        });
                        window.closeWaitMe($that);
                    }
                }
            }
        })
    })
}
